import html2canvas from "html2canvas";
import JsPDF from "jspdf";

export default function exportPDF(domId, fileName = "文件") {
  const dom = document.getElementById(domId);
  const originalHeight = dom.style.height;
  dom.style.height = "auto";

  html2canvas(dom, {
    scale: 2,
    useCORS: true,
    logging: false,
    width: dom.scrollWidth,
    height: dom.scrollHeight,
  }).then((canvas) => {
    dom.style.height = originalHeight;

    const pdf = new JsPDF("p", "pt", "a4");
    const imgWidth = 595.28;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const pageHeight = 841.89; // A4 高度
    let leftHeight = imgHeight;
    let position = 0;

    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
    leftHeight -= pageHeight;

    // 自动分页
    while (leftHeight > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      leftHeight -= pageHeight;
    }

    pdf.save(`${fileName}.pdf`);
  });
}



// WEBPACK FOOTER //
// ./src/utils/exportPdf.js